import { render, staticRenderFns } from "./UserPk.vue?vue&type=template&id=1b31d12e&scoped=true&"
import script from "./UserPk.vue?vue&type=script&lang=js&"
export * from "./UserPk.vue?vue&type=script&lang=js&"
import style0 from "./UserPk.vue?vue&type=style&index=0&id=1b31d12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31d12e",
  null
  
)

export default component.exports